import { useState } from 'react';

import { Typography } from '@mui/material';

import { say } from '@/james-playground/aa-family-claim/claim/asks';
import { text } from '@/james-playground/aa-family-claim/claim/facts';
import { APPROX } from '@/james-playground/aa-family-claim/claim/cards/cards.content';
import {
  ApproxDate,
  CardShell,
  Note,
} from '@/james-playground/aa-family-claim/claim/cards/parts';
import { type CardProps } from '@/james-playground/aa-family-claim/claim/cards/types';
import {
  approxReady,
  approxText,
  known,
  parseApprox,
  qualifiesFrom,
} from '@/james-playground/aa-family-claim/claim/cards/values';

const monthYear = (d: Date) =>
  d.toLocaleDateString('en-GB', { month: 'long', year: 'numeric' });

/**
 * Roughly when she started needing help: a month and a year, or the year
 * alone. The form takes a rough date. When it is under 6 months ago the claim
 * goes on, with a line saying when payment could start (rule R5.1).
 */
const ApproxDateCard = ({
  ask,
  facts,
  voice: v,
  onSubmit,
  onSkip,
  today = new Date(),
}: CardProps & { today?: Date }) => {
  const id = ask.entries[0];
  const [value, setValue] = useState(() => parseApprox(known(facts, id)));
  const from = qualifiesFrom(value);
  const waiting =
    id === 'careStartDate' &&
    text(facts, 'specialRules') !== 'Yes' &&
    approxReady(value) &&
    from &&
    from > today;

  return (
    <CardShell
      label={say(ask.title, v)}
      ready={approxReady(value)}
      onSkip={onSkip}
      onContinue={() =>
        onSubmit({ [id]: approxText(value) }, approxText(value))
      }
    >
      <ApproxDate
        label={say(ask.prompt, v)}
        value={value}
        onChange={setValue}
        today={today}
      />
      {waiting && from && (
        <Note>
          <Typography variant='body2'>
            {say(APPROX.waiting(monthYear(from)), v)}
          </Typography>
        </Note>
      )}
    </CardShell>
  );
};

ApproxDateCard.displayName = 'ApproxDateCard';
export default ApproxDateCard;
